import { type AnyElement, type AnyElementData } from '../all-element-types.ts';
import {
  type Element,
  type ElementData,
  elementType,
  type ElementType,
} from '../element.ts';

export enum PathHandleAxis {
  X = 0,
  Y = 1,
  NONE = 2,
}

export interface PathWaypointElementPasteData extends PathWaypointElementData {
  sourcePathIndex: number;
}

export interface PathWaypointElementData extends ElementData<ElementType> {
  /**
   * The id of the path this waypoint belongs to
   */
  sourcePathId: string;
  /**
   * The order of this waypoint on a path. Helps the path finding algorithm
   * determine which waypoints to go to first.
   */
  order: number;
  /**
   * The axis of this waypoint on a path. Used to restrict dragging on a handle
   */
  axis: PathHandleAxis;
}

export interface PathWaypointElement
  extends PathWaypointElementData, Element<ElementType> {}

export function isPathWaypoint(
  element: AnyElement | undefined,
): element is PathWaypointElement {
  return element !== undefined && element.type === pathWaypointElementType;
}
export function isPathWaypointData(
  element: AnyElementData | undefined,
): element is PathWaypointElementData {
  return !!element && element.type === pathWaypointElementType;
}

export const pathWaypointElementType = elementType('pathWaypoint');
